import { Badge, Flex } from "antd";
import { CHART_COLORS } from "utils/utils";

import styles from 'assets/css/Design.module.css';

interface TileProps {
    items: any[];
}

const TileTooltip: React.FC<TileProps> = ({ items }) => {
    return (
        <Flex gap="small" vertical className={styles.ChartTooltip}>
            {items.map((item, index) => (
                <Flex key={index} align='center' justify='space-between'>
                    <span className={styles.ChartTooltipText}><Badge color={CHART_COLORS[index]} />{item.name}</span>
                    <span>{item.data.valueText}</span>
                </Flex>
             ))}
        </Flex>
    );
}

export default TileTooltip;